import { style } from './MasonryGrid.style';
import { View } from 'react-native';
import { MasonryGridProps } from './MasonryGrid.types';
import { useMasonryGridLogic } from './MasonryGrid.logic';

export const MasonryGrid = ({ itemHeight = 240, gap = 0, outerGap = 0, children }: MasonryGridProps) => {
  const { containerStyle, masonryRef, layoutStyle, childElements } = useMasonryGridLogic({
    itemHeight,
    gap,
    outerGap,
    children,
  });
  return (
    <View style={containerStyle}>
      <View ref={masonryRef} style={[style.layout, layoutStyle]}>
        {childElements}
      </View>
    </View>
  );
};
